import gql from "graphql-tag";

import CartFragment from "../../../fragments/cart.fragment";

const GetCart = gql`
  query {
    cart {
      ...CartFragment
    }
  }
  ${CartFragment}
`;

export default GetCart;
